import { FunctionComponent } from 'react'

import useEnableEnhancedSearchPage from '@hooks/useEnableEnhancedSearchPage'
import EnhancedSearch from '@widgets/Search/EnhancedSearch'
import Search from '@widgets/Search/Search'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'

import { SearchWidgetProps } from './types'

const SearchWidget: FunctionComponent<SearchWidgetProps> = ({ ad }) => {
  const isEnhancedSearch = useEnableEnhancedSearchPage()
  return isEnhancedSearch ? <EnhancedSearch /> : <Search ad={ad} />
}

const widget = {
  kind: ['widget', 'search'],
  component: SearchWidget,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
